export default "__VITE_PUBLIC_ASSET__dd1f9baf__"